// The `~` strip's rows: the channels you are IN first (ChannelLinks.filter over the store, exactly
// the Mac's list), then the team's other public channels the server found for the same query —
// the webapp's "Other channels" tier, which the Mac lacks because its catalogue is the store.
// Deduplicated by slug (a joined channel the server also returns stays in the first tier).
import { ChannelLinks, type ChannelLinkTarget } from './channelLinks';

export interface ChannelSuggestion extends ChannelLinkTarget {
  joined: boolean;
}

export function suggestions(
  joined: readonly ChannelLinkTarget[],
  others: readonly ChannelLinkTarget[],
  query: string,
  limit = 8,
): ChannelSuggestion[] {
  const first = ChannelLinks.filter(joined, query, limit).map((t) => ({ ...t, joined: true }));
  if (first.length >= limit) return first;
  const seen = new Set(first.map((t) => t.slug));
  for (const t of joined) seen.add(t.slug);
  const rest = ChannelLinks.filter(
    others.filter((t) => !seen.has(t.slug) && !t.isPrivate),
    query,
    limit - first.length,
  ).map((t) => ({ ...t, joined: false }));
  return [...first, ...rest];
}

export const ChannelSuggestions = { suggestions } as const;
